import TodoListItem, {TodoType} from "./items/item"
import DatetimeUtils from "../../gd/utils/datetime-utils";
import {TodoListAccess} from "./const";

const debug = false
// const debug = "TodoList"

export default class TodoList {

    public manager            : any

    public uid                : ID

    public title              : string
    public momentCreated      : Moment
    public createdByUserId    : ID|null

    public access             : TodoListAccess

    public items            : TodoListItem[]

    constructor(manager:any, serializedTodoList:any) {

        debug && console.log(debug, "constructor", manager, serializedTodoList)
        this.manager            = manager

        this.uid                = serializedTodoList.uid

        this.title              = _.get(serializedTodoList,'title','Todo List')
        this.momentCreated      = DatetimeUtils.datetimeToMoment(_.get(serializedTodoList,'momentCreated',null))
        this.createdByUserId    = _.get(serializedTodoList,'createdByUserId',null)

        // init access
        this.access = {
            add : !this.manager || this.manager.access.add,
            edit: !this.manager || this.manager.access.edit || this.createdByUserId === gd.session.me.id
        }

        this.items = _.chain(
            _.get(serializedTodoList,'items',[])).compact().map(item=>TodoListItem.create(this, item)
        ).value()
    }

    get ids() {
        return _.map(this.items, item=>item.uid)
    }

    public generateId():ID {
        return gd.utils.generateUIDWithCollisionChecking(this.ids)
    }

    static create(manager:any, data:any) {
        data.momentCreated      = moment()
        data.createdByUserId    = gd.session.me.id

        return new TodoList(manager, data)
    }

    setTitle(value:string) {
        if (value === '') value = "Todo List"
        this.title = value
    }

    getItem = (uid:ID) => _.find(this.items,['uid', uid])
    getItemByMessageId = (messageId:ID) => {
        // @ts-ignore
        return _.find(this.items, item => item.properties.messageId === messageId)
    }
    addItem(item:TodoListItem) {
        this.items.push(item)
    }

    deleteItem(uid:ID) {
        _.remove(this.items, item=>item.uid === uid)
    }

    pushItemAt(newItem:TodoListItem, targetUid:ID, type:string='') {
        //remove no items at index and add newItem at this position
        const uidArray = _.map(this.items, item=>item.uid);
        const index = _.indexOf(uidArray, targetUid);
        switch (type) {
            case 'below':
                this.items.splice(index+1,0,newItem);
                break
            case 'above':
            default     :
                this.items.splice(index,0,newItem);
                break
        }
    }

    replaceItem(newItem:TodoListItem, targetUid:ID) {
        this.pushItemAt(newItem, targetUid)
        this.deleteItem(targetUid)
    }

    getItems = (ignoreCompleted:boolean) => {
        return ignoreCompleted ? _.filter(this.items, item => !item.isCompleted) : this.items
    }

    getCounters = () => ({
        total       : this.items.length,
        completed   : _.filter(this.items, item => item.isCompleted).length
    })

    messageHasInList(messageId: ID) {
        return _.find(this.items, (item: TodoListItem)=>item.properties.messageId === messageId)
    }

    get length() {
        return this.items.length
    }

    get completedItemsLength() {
        return _.filter(this.items, item => item.isCompleted).length
    }

    get uncompletedItemsTotal() {
        return _.filter(this.items, item => !item.isCompleted).length
    }

    toText() {
        let res = ''
        _.map(this.items, item=>{
            res += item.toText() + '\n'
        })
        return res
    }

    toJSON() {
        return {
            uid             : this.uid,
            title           : this.title,
            momentCreated   : this.momentCreated,
            createdByUserId : this.createdByUserId,
            items           : _.map(this.items, item=>(item.toJSON()))
        }
    }
}
